/* MIRIJANA — Beschreibungstext aus der Buy-Box herausheben.
   Die Beschreibungs-Bloecke liegen technisch in der rechten Produktspalte und
   werden deshalb nur auf der rechten Haelfte gerendert. Sie werden in der
   richtigen Reihenfolge herausgehoben — WICHTIG: immer OBERHALB der Reviews,
   so wie auf allen anderen Produktseiten.
   Das Trustoo-Widget wird per JS nachgeladen; sobald es erscheint, wird die
   Position noch einmal korrigiert. Faellt bei jedem Fehler still zurueck. */
(function () {
  var done = false;

  function reviewsEl() {
    return document.querySelector('#trustoo-widget-wrapper, .trustoo-widget-wrapper');
  }

  function place() {
    try {
      var info = document.querySelector('.product__info-container');
      // Manche Produkte (z. B. NION-Heilung) haben keinen .coaching-container,
      // sondern nur Shopifys Standard-Beschreibung. Die wird genauso behandelt —
      // aber nur, wenn es KEINEN coaching-container gibt, sonst waere der Text doppelt.
      var parts = document.querySelectorAll('.coaching-container');
      if (!parts.length) parts = document.querySelectorAll('.product__description');
      if (!parts.length) return;

      // Ankerpunkt: direkt VOR den Reviews, sonst hinter dem Produktbereich
      var rev = reviewsEl();
      var anchor, parent;
      if (rev && rev.parentNode) {
        parent = rev.parentNode;
        anchor = rev;
      } else {
        var sec = info && (info.closest('.shopify-section') || info.closest('.product'));
        if (!sec || !sec.parentNode) return;
        parent = sec.parentNode;
        anchor = sec.nextSibling;
      }

      Array.prototype.forEach.call(parts, function (el) {
        el.classList.add('mj-lifted');
        parent.insertBefore(el, anchor);
      });
      done = true;
    } catch (e) { /* Layout darf daran nie scheitern */ }
  }


  /* Aufzaehlung unter dem Titel einheitlich einfaerben.
     Die Zeilen stehen je nach Produkt als <div> mit unterschiedlicher
     inline-Farbe (#333, #545454, ...) im HTML. Statt jede Variante per CSS
     zu erraten, werden sie hier markiert — die Farbe kommt dann aus dem
     Stylesheet (.mj-bullet-text). */
  function markBullets() {
    try {
      var box = document.querySelector('.product__info-container');
      if (!box) return;
      var nodes = box.querySelectorAll('div, p');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.children.length > 3) return;
        var t = (el.textContent || '').trim();
        if (!t || t.length > 400) return;
        if (t.indexOf('\u2022') === -1) return;      // enthaelt einen Bullet-Punkt
        el.classList.add('mj-bullet-text');
      });
    } catch (e) {}
  }

  function addViaProductForm() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var submit = form && form.querySelector('[type="submit"]');
    if (!form || !submit || submit.getAttribute('aria-disabled') === 'true') return false;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
    else submit.click();
    return true;
  }

  /* Heilreise Einmalzahlung adds to cart. Ratenzahlung stays on CopeCart. */
  function heilreiseToCart() {
    if (!/\/products\/heilreise-ins-shalia-bewusstsein\/?$/.test(location.pathname)) return;
    var busy = false;
    function go(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (busy) return;
      busy = true;
      var form = document.querySelector('product-form form[action*="/cart/add"]');
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput) { idInput.disabled = false; idInput.value = '42091487854640'; }
      addViaProductForm();
      setTimeout(function () { busy = false; }, 1200);
    }
    var picker = document.querySelector('variant-selects, variant-radios');
    if (picker && !picker.dataset.mjCart) {
      picker.dataset.mjCart = '1';
      picker.addEventListener('click', function (e) {
        if (e.target.closest('label, input[type="radio"]')) go(e);
      }, true);
    }
  }

  /* Seelenhaus: only Einmalzahlung adds to cart. The two Ratenzahlung buttons stay on PayPal. */
  function seelenhausToCart() {
    if (!/\/products\/dein-shalia-seelenhaus\/?$/.test(location.pathname)) return;
    var button = document.querySelector('a.slh-btn.is-primary');
    if (!button || button.dataset.mjCart) return;
    button.dataset.mjCart = '1';
    button.setAttribute('href', '#');
    var busy = false;
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (busy) return;
      busy = true;
      var form = document.querySelector('product-form form[action*="/cart/add"]');
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput) { idInput.disabled = false; idInput.value = '43583369347120'; }
      addViaProductForm();
      setTimeout(function () { busy = false; }, 1200);
    });
  }

  function start() {
    markBullets();
    heilreiseToCart();
    seelenhausToCart();
    place();
    // Reviews kommen asynchron — danach Position einmal nachziehen
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (reviewsEl()) { place(); clearInterval(t); }
      else if (tries > 40) clearInterval(t);   // nach ~10s aufgeben
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
